import { ISearchResultComponentFactory } from "../interfaces";

interface IFilterItemDecision {
    section: string;
    status: string;
}

const filterItemDecisions: ISearchResultComponentFactory<IFilterItemDecision[]> = {

    key: "filterItemDecisions",

    createElement: value => {
        const element = document.createElement('ul');
        element.className = "text-sm mt-2";

        value.forEach(item => {
            let backgroundColor = "";
            item.status.split(',').forEach(status => {
                switch (status.toUpperCase()) {
                    case "COMPLAINT NOT UPHELD":
                        backgroundColor = "#edcece";
                        break;
                    case "COMPLAINT UPHELD":
                        backgroundColor = "#bfe1cf";
                        break;
                    case "COMPLAINT PARTLY UPHELD":
                        backgroundColor = "#fbe7d1";
                        break;
                }

                const li = document.createElement('li');
                li.className = "mr-3 mt-1 inline-block";
                li.innerHTML = `<span class="text-neutral-600">${item.section}:</span><span class="p-1 inline-block ml-2" style="background-color: ${backgroundColor};">${status}</span>`;
                element.appendChild(li);
            });
        });

        return element;
    },
};

export default filterItemDecisions;
